"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _DropDown = _interopRequireDefault(require("../../DropDown"));

var _listRender = _interopRequireDefault(require("../utils/listRender"));

var _selectRender = _interopRequireDefault(require("../utils/selectRender"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../../DropDown/constants");

var _listFilterFunction = _interopRequireDefault(require("../utils/listFilterFunction"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DropDownFilter =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(DropDownFilter, _React$Component);

  function DropDownFilter() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, DropDownFilter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(DropDownFilter)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      query: null
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleClose", function () {
      _this._autoSelectFromQuery();

      _this.setState({
        query: null
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_listRender", function (props) {
      _this.list = props.list;
      return (0, _listRender["default"])(_objectSpread({}, props, {
        query: _this.state.query,
        searchFilter: _this.props.searchFilter
      }));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_selectRender", function (props) {
      _this.select = props.select;
      _this.open = props.open;
      return (0, _selectRender["default"])(_objectSpread({}, props, {
        query: _this.state.query,
        onChange: _this._handleQueryChange,
        onKeyDown: function onKeyDown(event) {
          return _this._handleQueryKeyDown(event, props.focus);
        },
        onFocus: function onFocus() {
          return _this.focused = true;
        },
        onBlur: function onBlur() {
          return _this.focused = false;
        }
      }));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleListChange", function () {
      if (_this.focused && typeof _this.open === 'function') {
        _this.open();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleQueryKeyDown", function (event, focus) {
      if (event.key === _constants.KEY_ARROW_DOWN || event.key === _constants.KEY_ARROW_UP) {
        event.preventDefault();
        focus(event.key === _constants.KEY_ARROW_DOWN ? _constants.LIST_ITEM_POSITION_FIRST : _constants.LIST_ITEM_POSITION_LAST);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleQueryChange", function (event) {
      event.persist();

      _this.setState({
        query: event.target.value
      }, function () {
        if (typeof _this.props.onInput === 'function') {
          _this.props.onInput(event);
        }
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(DropDownFilter, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_DropDown["default"], (0, _extends2["default"])({}, this.props, {
        focusListOnOpen: false,
        listRender: this._listRender,
        selectRender: this._selectRender,
        theme: null,
        onClose: this._handleClose,
        onListChange: this._handleListChange
      }));
    }
  }, {
    key: "_autoSelectFromQuery",
    value: function _autoSelectFromQuery() {
      var query = this.state.query,
          value = this.props.value;

      if (query !== null && this.list) {
        var list;

        if (query) {
          list = this.list.filter((0, _listFilterFunction["default"])(query, this.props.searchFilter));
        } else {
          list = [];
        }

        if (list.length) {
          var first = list[0].id;

          if (value) {
            if (!list.find(function (item) {
              return item.id === value;
            })) {
              this.select(first);
            }
          } else {
            this.select(first);
          }
        } else {
          // введенное значение пустое - обнуляем текущее
          this.select(null);
        }
      }
    }
  }]);
  return DropDownFilter;
}(_react["default"].Component);

DropDownFilter.propTypes = {
  searchFilter: _propTypes["default"].func,
  onInput: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
var _default = DropDownFilter;
exports["default"] = _default;